import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import {confirmAlert} from 'react-confirm-alert';


class FooterViewComponent extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      email: ''
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const error = this.props.errors || [];
    const {t, success} = this.props;
    if (error.length || success) {
      confirmAlert({
        message: success ? t('subscribed') : t(error[0]),
        buttons: [
          {
            label: t('continue'),
            onClick: () => {
              if (success) {
                this.setState({
                  email: ''
                });
              }
              this.props.clearError();
            },
          },
        ],
      });
    }
  }

  handleChange(event) {
    this.setState({
      email: event.target.value
    });
    this.props.clearError();
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.subscribe({
      email: this.state.email
    });
  }

  render() {
    const {email} = this.state;
    const {t} = this.props;
    return (
      <footer className="app__footer">
        <div className="app__wrapper">
          <div className="newsletter">
            <h4 className="newsletter__title">{t('newsletter')}</h4>
            <div className="newsletter__subtitle">{t('recieve_our_specials')}</div>
            <div className="newsletter__form-wrap">
                <form className="newsletter__form" onSubmit={this.handleSubmit}>
                <input
                  name='email'
                  autoComplete='off'
                  type="text"
                  placeholder={t('enter_email_newsletters')}
                  className="newsletter__input"
                  value={email}
                  onChange={this.handleChange}
                />
                <button
                  className="newsletter__btn"
                >
                </button>
              </form>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

FooterViewComponent.propTypes = {
  errors: PropTypes.array,
  subscribe: PropTypes.func
};

export default translate('translations')(FooterViewComponent);



// WEBPACK FOOTER //
// ./src/components/Footer/FooterView.js